module.exports = __webpack_public_path__ + "media/flags/fj-c5373bc1.svg";